// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwImageCell from 'viewmodel/AwImageCellViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "props": {
        "collaborationspaceid": {
            "type": "string"
        },
        "acc-id": {
            "type": "string"
        },
        "accsessionid": {
            "type": "string"
        },
        "autoSelectFirst": {
            "type": "boolean"
        }
    },
    "lifecycleHooks": {
        "onMount": "reveal"
    },
    "dataProviders": {
        "ListOfUsers": {
            "action": "getUsers",
            "response": "{{data.searchResults}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "data": {
        "limit": 50
    },
    "actions": {
        "reveal": {
            "actionType": "dataProvider",
            "method": "ListOfUsers"
        },
        "getUsers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "accsessionid": "{{props.accsessionid}}",
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListCollabSpaceMembers($listInput: ListInput) {listCollabSpaceMembers(listInput: $listInput) }",
                        "variables": {
                            "listInput": {
                                "searchOptions": {
                                    "skip": 0,
                                    "limit": 10,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "searchResults": "data.data.listCollabSpaceMembers.userList",
                "totalFound": "data.data.listCollabSpaceMembers.totalFound"
            },
            "events": {},
            "deps": "js/accHttpService"
        }
    },
    "onEvent": [],
    "messages": {},
    "conditions": {},
    "i18n": {},
    "_viewModelId": "DesUserList",
    "_uniqueViewModelId": "DesUserList",
    "ctx": {}
};

    /*
    <aw-panel class="des-image-styling-userList">
    <aw-list dataprovider="data.dataProviders.ListOfUsers">
        <aw-image-cell vmo="item"> </aw-image-cell>
    </aw-list>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="des-image-styling-userList">
        <AwList dataprovider={dataProviders.ListOfUsers} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>            <AwImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
            </AwImageCell></> } }
        </AwList>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;